module.exports = __webpack_public_path__ + "img/chargingstation-gemeente.f1d8a035.svg";